import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { track } from "@/lib/analytics";

const COPY = {
  pt: {
    label: "Saltar para",
    items: [
      { href: "#teacher", text: "Sobre o professor" },
      { href: "#aulas-de-frances", text: "Modalidades" },
      { href: "#niveis", text: "Níveis A1 → C2" },
      { href: "#metodologia", text: "Metodologia" },
      { href: "#depoimentos-de-alunos", text: "Depoimentos" },
      { href: "#contato-leadgen", text: "Aula grátis" },
    ],
  },
  en: {
    label: "Jump to",
    items: [
      { href: "#teacher", text: "About the teacher" },
      { href: "#aulas-de-frances", text: "Class formats" },
      { href: "#niveis", text: "Levels A1 → C2" },
      { href: "#metodologia", text: "Methodology" },
      { href: "#depoimentos-de-alunos", text: "Testimonials" },
      { href: "#contato-leadgen", text: "Free lesson" },
    ],
  },
  fr: {
    label: "Aller à",
    items: [
      { href: "#teacher", text: "À propos du prof" },
      { href: "#aulas-de-frances", text: "Modalités" },
      { href: "#niveis", text: "Niveaux A1 → C2" },
      { href: "#metodologia", text: "Méthodologie" },
      { href: "#depoimentos-de-alunos", text: "Témoignages" },
      { href: "#contato-leadgen", text: "Cours offert" },
    ],
  },
};

const SectionIndex = () => {
  const { lang } = useLanguage();
  const t = COPY[lang] || COPY.pt;

  return (
    <nav
      data-testid="section-index"
      aria-label={t.label}
      className="border-y border-[#e5e3db] bg-[#f4f1ea]/60 backdrop-blur-sm"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 py-4 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
        <span className="text-[10px] sm:text-xs uppercase tracking-[0.22em] text-[#9a9a9a] shrink-0">
          {t.label}
        </span>
        <ol className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-[#1e2a5a]">
          {t.items.map((item, i) => (
            <li key={item.href} className="flex items-center gap-5">
              <a
                href={item.href}
                data-testid={`section-index-link-${i + 1}`}
                onClick={() =>
                  track("section_index_click", {
                    target: item.href,
                    position: i + 1,
                    lang,
                  })
                }
                className="link-underline whitespace-nowrap"
              >
                <span className="text-[#d9381e] font-medium mr-1.5 tabular-nums">
                  {String(i + 1).padStart(2, "0")}
                </span>
                {item.text}
              </a>
              {i < t.items.length - 1 && (
                <span aria-hidden="true" className="text-[#d8d6cd] hidden sm:inline">
                  ·
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default SectionIndex;
